export const selectStudyNoteFor = (ticker) => (state) =>
  ticker ? state.study.notes?.[ticker] ?? null : null;

export const selectWatchlist = (state) => state.study.watchlist || [];

export const selectIsOnWatchlist = (ticker) => (state) =>
  Boolean(
    ticker &&
      (state.study.watchlist || []).some((row) => row.ticker_name === ticker)
  );

export const selectNoteTickers = (state) => state.study.noteTickers || [];

export const selectHasNoteFor = (ticker) => (state) =>
  Boolean(ticker && (state.study.noteTickers || []).includes(ticker));
